import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "app/app.module";
import { environment } from "environments/environment";

if (environment.production) {
	enableProdMode();
}

(async () => {
	await platformBrowserDynamic().bootstrapModule(AppModule);
})()
	.then(() => {
		// nothing to do, just need to handle promise for linter
	})
	.catch((e) => {
		// fall through for errors not handled in code
		// tslint:disable-next-line:no-console
		console.error(e);
	});

